import { useTranslations } from '@vocab/react';
import {
  Column,
  Columns,
  Heading,
  Hidden,
  Stack,
  Text,
  Inline,
  TextLink,
  IconNewWindow,
  Actions,
} from 'braid-design-system';
import { useEffect, useState } from 'react';

import { events, link } from 'src/modules/analyticsTracker';
import {
  auBrandingGuidelinesUrl,
  getBrandingGuidelinesUrl,
} from 'src/utils/urls';

import translations from './.vocab';
import { CanvaButton } from './CanvaButton';
import { PreviewDevicesImage } from './PreviewDevicesImage';

const IntroBanner = () => {
  const [brandingGuidelinesUrl, setBrandingGuidelinesUrl] = useState(
    auBrandingGuidelinesUrl,
  );

  const onBrandingGuidelinesClick = () => {
    link(events.BRANDING_GUIDELINES_INTERACTED);
  };

  useEffect(() => {
    setBrandingGuidelinesUrl(getBrandingGuidelinesUrl());
  }, []);

  const { t } = useTranslations(translations);

  return (
    <Columns space="xxlarge" collapseBelow="tablet">
      <Column>
        <Stack space="xlarge">
          <Heading level="1">{t('Logos & Brands')}</Heading>
          <Stack space="medium">
            <Heading level="3">{t('Elevate your Job Ad')}</Heading>
            <Text tone="neutral">{t('Personalise each brand')}</Text>
            <Inline alignY="center" space="small">
              <Text>
                <TextLink
                  href={brandingGuidelinesUrl}
                  target="_blank"
                  onClick={onBrandingGuidelinesClick}
                  iconPosition="trailing"
                  icon={<IconNewWindow />}
                >
                  {t('Branding guidelines')}
                </TextLink>
              </Text>
            </Inline>
            <Text tone="neutral">{t('No cover image')}</Text>
            <Actions>
              <CanvaButton />
            </Actions>
          </Stack>
        </Stack>
      </Column>
      <Column width="content">
        <Hidden below="tablet">
          <PreviewDevicesImage />
          <Text tone="secondary" align="center" size="small">
            {t('Example ad with logo and cover image')}
          </Text>
        </Hidden>
      </Column>
    </Columns>
  );
};

export default IntroBanner;
